import React from 'react';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { LANGUAGES, setStoredLanguage } from 'utils/language.utils';
import './language-switch.style.scss';

const LanguageSwitch: React.FC = () => {
  const { i18n } = useTranslation();
  const current = (i18n.language || 'ru').split('-')[0];

  const change = (code: string) => {
    if (code === current) return;
    setStoredLanguage(code);
    void i18n.changeLanguage(code);
  };

  return (
    <div className="langSwitch" role="group" aria-label="Language">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={clsx('langSwitch__btn', current === code && 'langSwitch__btn--active')}
          onClick={() => change(code)}
          aria-pressed={current === code}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitch;
